// src/hooks/useChecklistSends.js
// custcopy-32471cbd — CHECKLISTS SEAM 8c (web). Live list of the checklists emailed to the customer from
// one job (organizations/{orgId}/checklistCopySends, one server-written record per send), grouped by
// checklist, newest first — for the "Sent to … by … · date" lines in JobChecklistsPanel.
//
// A single-field equality filter (no new index), sorted here. `enabled` = office roles only: firestore.rules
// lets nobody else read these records (they hold the customer's address and the message). Staff-only:
// never use this in a portal view.

import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';

const millis = (v) => (v?.toMillis ? v.toMillis() : (v instanceof Date ? v.getTime() : 0));

const useChecklistSends = ({ orgId, jobId, enabled = true }) => {
    const [byChecklist, setByChecklist] = useState({});

    useEffect(() => {
        if (!enabled || !orgId || !jobId) {
            setByChecklist({});
            return undefined;
        }
        return onSnapshot(
            query(collection(db, `organizations/${orgId}/checklistCopySends`), where('jobId', '==', jobId)),
            (snap) => {
                const out = {};
                for (const d of snap.docs) {
                    const s = { id: d.id, ...d.data() };
                    (out[s.checklistId] = out[s.checklistId] || []).push(s);
                }
                for (const k of Object.keys(out)) out[k].sort((a, b) => millis(b.at) - millis(a.at));
                setByChecklist(out);
            },
            (err) => {
                console.error('useChecklistSends: listener failed', err);
                setByChecklist({});
            },
        );
    }, [orgId, jobId, enabled]);

    return byChecklist;
};

export default useChecklistSends;
